var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalenderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2148_35166)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2148_35166",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 10,
    height: 10
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H10V10H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2148_35166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.82132 4.28572C5.24514 4.28572 5.65944 4.16004 6.01183 3.92458C6.36422 3.68912 6.63888 3.35445 6.80107 2.96289C6.96325 2.57134 7.00569 2.14048 6.92301 1.72481C6.84032 1.30913 6.63624 0.927313 6.33655 0.627629C6.03687 0.327945 5.65505 0.123858 5.23937 0.0411754C4.8237 -0.0415073 4.39284 0.00092847 4.00129 0.163116C3.60973 0.325304 3.27506 0.599959 3.0396 0.95235C2.80414 1.30474 2.67847 1.71904 2.67847 2.14286C2.67847 2.71118 2.90423 3.25622 3.3061 3.65809C3.70796 4.05995 4.253 4.28572 4.82132 4.28572ZM4.82132 0.714287C5.10387 0.714287 5.38007 0.798071 5.615 0.955044C5.84992 1.11202 6.03303 1.33513 6.14115 1.59617C6.24928 1.8572 6.27757 2.14444 6.22245 2.42156C6.16732 2.69867 6.03127 2.95322 5.83148 3.15301C5.63169 3.3528 5.37714 3.48886 5.10002 3.54398C4.82291 3.5991 4.53567 3.57081 4.27463 3.46269C4.0136 3.35456 3.79048 3.17146 3.63351 2.93653C3.47654 2.7016 3.39275 2.4254 3.39275 2.14286C3.39275 1.76398 3.54326 1.40061 3.81117 1.13271C4.07908 0.864796 4.44244 0.714287 4.82132 0.714287Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.82143 5C2.225 5 0 6.78571 0 8.21429C0 9.78929 2.43571 10 4.82143 10C7.20714 10 9.64286 9.78929 9.64286 8.21429C9.64286 6.78571 7.41786 5 4.82143 5ZM4.82143 9.28571C3.80714 9.28571 0.714286 9.28571 0.714286 8.21429C0.714286 7.22857 2.55357 5.71429 4.82143 5.71429C7.08928 5.71429 8.92857 7.22857 8.92857 8.21429C8.92857 9.28571 5.83571 9.28571 4.82143 9.28571Z",
    fill: "#1A1A1A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2148_35166"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderIcon);
export default __webpack_public_path__ + "static/media/calender-icon.1c1f83c12d023782c82bfb68d71288ac.svg";
export { ForwardRef as ReactComponent };